<mat-sidenav-container autosize>
  <mat-sidenav #sidenav id="main-navigation" class="drop-shadow-md" fixedInViewport="true" mode="side" [opened]="showSidebar" [disableClose]="true" [ngClass]="{ 'slim': !isExpanded }">
    @if (showSidebar) {
      <div class="flex flex-col h-full">
        <a class="block overflow-hidden shrink-0 h-14" routerLink="">
          <img [src]="isExpanded ? defaultLogo : defaultLogoSmall" alt="Lead Advantage Pro" fetchpriority="high" />
        </a>

        <div class="flex flex-col h-full justify-between m-2">
          <div>
            @if (isExpanded) {
              <button type="button" class="w-full" mat-flat-button id="qlBtn" matTooltip="Open Quick Links" (click)="openQuickLinks()">Quick Links</button>
            } @else {
              <button type="button" mat-mini-fab color="primary" id="qlBtn" matTooltip="Open Quick Links" class="mb-1" (click)="openQuickLinks()">
                <mat-icon>expand_more</mat-icon>
              </button>
              <button type="button" mat-mini-fab color="primary" matTooltip="Open Quick Actions" [matMenuTriggerFor]="quickActionsMenu">
                <mat-icon>add</mat-icon>
              </button>
            }

            <mat-nav-list>
              @if (isExpanded) {
                <div mat-subheader>Menu</div>
              }

              <a mat-list-item [routerLink]="['/']" title="Go back to Dashboard" class="min-h-12">
                <mat-icon matListItemIcon>dashboard</mat-icon>
                @if (isExpanded) {
                  <span matListItemTitle>Dashboard</span>
                }
              </a>

              <a mat-list-item [routerLink]="['/lead']" title="Display Leads" [activated]="isActiveUrl('/lead')" (click)="redirectTo(lead_url)" class="min-h-12">
                <mat-icon matListItemIcon>group</mat-icon>
                @if (isExpanded) {
                  <span matListItemTitle>Leads</span>
                }
                @if (isExpanded) {
                  <button matListItemMeta mat-icon-button (click)="addLead($event);" aria-label="Create New Lead">
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </a>

              <a mat-list-item [routerLink]="['/calendar']" title="Display Calendar" [activated]="isActiveUrl('/calendar')" (click)="redirectTo(calendar_url)" class="min-h-12">
                <mat-icon matListItemIcon>calendar_month</mat-icon>
                @if (isExpanded) {
                  <span matListItemTitle>Calendar</span>
                }
                @if (isExpanded) {
                  <button matListItemMeta mat-icon-button (click)="addEvent($event);" aria-label="Add Task/Appointment">
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </a>

              <a mat-list-item [routerLink]="['/quotes']" title="Display Quotes" [activated]="isActiveUrl('quotes/')" (click)="redirectTo(quote_url)" class="min-h-12">
                <mat-icon matListItemIcon>event</mat-icon>
                @if (isExpanded) {
                  <span matListItemTitle>Quotes</span>
                }
                @if (isExpanded) {
                  <button matListItemMeta mat-icon-button aria-label="Create Quote" [matMenuTriggerFor]="quickQuoteMenu" (click)="preventRedirectButton($event)">
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </a>

              <a mat-list-item [routerLink]="['/forms']" title="Display Forms" (click)="redirectTo(form_url)" [activated]="isActiveUrl('forms/')" class="min-h-12">
                <mat-icon matListItemIcon>description</mat-icon>
                @if (isExpanded) {
                  <span matListItemTitle>Forms</span>
                }
              </a>

              <a mat-list-item [routerLink]="['/reports']" title="Display Reports" (click)="redirectTo(report_url)" [activated]="isActiveUrl('/reports')" class="min-h-12">
                <mat-icon matListItemIcon>bar_chart</mat-icon>
                @if (isExpanded) {
                  <span matListItemTitle>Reports</span>
                }
              </a>
            </mat-nav-list>
          </div>

          <div>
            <mat-nav-list>
              @if (commonService.hasPermission('ui_admin')) {
                <a mat-list-item [routerLink]="['/admin']" title="Display Admin" (click)="redirectTo(admin_url)" [activated]="isActiveUrl('/admin')" class="min-h-12">
                  <mat-icon matListItemIcon>admin_panel_settings</mat-icon>
                  @if (isExpanded) {
                    <span matListItemTitle>Admin</span>
                  }
                </a>
              }

              <a mat-list-item [routerLink]="['/help']" title="Display Help" class="min-h-12">
                <mat-icon matListItemIcon>help_outline</mat-icon>
                @if (isExpanded) {
                  <span matListItemTitle>Help</span>
                }
              </a>

              <a mat-list-item [routerLink]="['/privacy_policy']" title="Display Privacy Policy" class="min-h-12">
                <mat-icon matListItemIcon>lock</mat-icon>
                @if (isExpanded) {
                  <span matListItemTitle>Privacy Policy</span>
                }
              </a>
            </mat-nav-list>

            <mat-list>
              @if (isExpanded) {
                <mat-list-item>
                  <span class="text-xs text-slate-800">{{'v'+ versionNumber }}</span>
                </mat-list-item>
              }
            </mat-list>
          </div>
        </div>
      </div>
    }
  </mat-sidenav>

  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>

  <!-- sidenav used currently for additional filters for quoting -->
  <mat-sidenav #panel class="panel drop-shadow-md" fixedInViewport="true" mode="over" [disableClose]="true" position="end">
    <ng-container #content></ng-container>
  </mat-sidenav>
</mat-sidenav-container>

<mat-menu #quickActionsMenu="matMenu">
  <ng-template matMenuContent>
    <button mat-menu-item (click)="addLead($event)">Create New Lead</button>
    <button mat-menu-item (click)="addEvent($event)">Create New Calendar Event</button>
    @if (leadDetails) {
      <button mat-menu-item (click)="addQuote(true)">Create Quote for <strong>{{leadDetails.client_agent_facing_name}}</strong></button>
    }
    <button mat-menu-item (click)="addQuote()">Create New Quote</button>
  </ng-template>
</mat-menu>

<mat-menu #quickQuoteMenu="matMenu">
  <ng-template matMenuContent>
    @if (leadDetails) {
      <button mat-menu-item (click)="addQuote(true)">Create Quote for <strong>{{leadDetails.client_agent_facing_name}}</strong></button>
    }
    <button mat-menu-item (click)="addQuote()">Create New Quote</button>
  </ng-template>
</mat-menu>
